import React from "react";
import { Link } from "react-router-dom";
import Footer from "../footer/Footer";
import TopBar from "../header/navbar/TopBar";
import "./location.css";
function Location() {
  return (
    <div>
      <section className=" only-desktop">
        <div className="location">
          <TopBar />
          <div className="container">
            <h1 className="tag">
              Choose a location to place your lighthouse and/or pasty van And
              make sure you have opted in to ASA: (pasty token asa id)
            </h1>
          </div>
          <div className="location-content ">
            <div className="left">
              <Link to="/weststake">
                <img
                  src="\assets\images\location\west1.png"
                  alt=""
                  className="img-fluid"
                />
              </Link>
            </div>
            <div className="center">
              <Link to="/northstake">
                <img
                  src="\assets\images\location\north1.png"
                  alt=""
                  className="img-fluid topimg"
                />
              </Link>

              <Link to="/southstake">
                <img
                  src="\assets\images\location\south1.png"
                  alt=""
                  className="img-fluid btmimg"
                />
              </Link>
            </div>
            <div className="right">
              <Link to="/eaststake">
                <img
                  src="\assets\images\location\east1.png"
                  alt=""
                  className="img-fluid"
                />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="only-mobile">
        <TopBar />

        <h1 className="choose-location">
          Choose a location to place your lighthouse and/or pasty van And make
          sure you have opted in to ASA: (pasty token asa id)
        </h1>
        <div className="divider"></div>

        <div className="mobile-head">
          <h1>East</h1>
        </div>

        <div className="east-map ">
          <Link to="/eaststake">
            <img
              src="\assets\images\location\eastMobile.png"
              alt=""
              className="img-fluid"
            />
          </Link>
        </div>

        <div className="divider"></div>

        <div className="mobile-head">
          <h1>West</h1>
        </div>

        <div className="west-map ">
          <Link to="/weststake">
            <img
              src="\assets\images\location\westMobile.png"
              alt=""
              className="img-fluid"
            />
          </Link>
        </div>

        <div className="divider"></div>

        <div className="mobile-head">
          <h1>North</h1>
        </div>

        <div className="north-map">
          <Link to="/northstake">
            <img
              src="\assets\images\location\northMobile.png"
              alt=""
              className="img-fluid"
            />
          </Link>
        </div>

        <div className="divider"></div>

        <div className="mobile-head">
          <h1>south</h1>
        </div>

        <div className="south-map">
          <Link to="/southstake">
            <img
              src="\assets\images\location\northMobile.png"
              alt=""
              className="img-fluid"
            />
          </Link>
        </div>
      </section>

      <div className="grey-foot">
        <Footer />
      </div>
    </div>
  );
}

export default Location;
